const prepareColor = (color?: string[] | string | null): string => {
  if (Array.isArray(color)) {
    return color[0] || 'white';
  }

  return color || 'white';
};

export { prepareColor };
